<template>
    <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
        <h4 class="label-black" style="margin-bottom: 0px;">SOLICITUDES ACTIVAS</h4>
        <h6 class="label-black" v-if="AreaQueConsulta.Area.AreaId==21 && AreaQueConsulta.Area.AreaId!=0" style="margin-top: 0px;">Gestión de Solicitudes de documentos</h6>
        <h6 class="label-black" v-else-if="AreaQueConsulta.Area.AreaId!=21 && AreaQueConsulta.Area.AreaId!=0" style="margin-top: 0px;">Listado de Archivo Devueltos</h6>
        </div>
        <div class="row d-flex" v-if="AreaQueConsulta.Area.AreaId==21 && AreaQueConsulta.Area.AreaId!=0">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low">
                <div class="area custom-area">
                    <div v-if="UsuarioJuzgado.AreaAsignado.AreaId == 21">
                        <h5 class="label-black">Listado de Solicitudes Públicas Activas de {{UsuarioJuzgado.AreaAsignado.Nombre}} en el Archivo Judicial,  Total:  {{this.Solicitudes.length}}</h5>
                        <div id="Solicitudes_table" class="table-responsive">
                            <table class="table table-striped table-light table-hover table-sm">
                                <thead class="thead-custom">
                                    <tr>
                                        <th>Solicitud</th>
                                        <th>Área</th>
                                        <th>Tipo Documento</th>
                                        <th class="text-center">Consecutivo</th>
                                        <th >Estatus</th>
                                        <th v-if="UsuarioJuzgado.AreaAsignado.AreaId == 21">Sede</th>
                                        <!-- <th></th> -->
                                        <th class="text-center">Devolución</th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-if="Solicitudes.length <= 0">
                                        <td colspan="12" class="text-center">No hay registro de Solicitudes en área seleccionada</td>
                                    </tr>
                                    <tr v-else v-for="Lista in Solicitudes" :key="Lista.SolicitudDocumentoId">
                                        <td>{{Lista.SolicitudDocumentoId}}</td>
                                        <td>{{Lista.InventarioDocumentos.Area.Nombre}}</td>
                                        <td>{{Lista.InventarioDocumentos.TipoDocumento.Nombre}}</td>
                                        <td class="text-center">{{Lista.InventarioDocumentos.Consecutivo}}/{{Lista.InventarioDocumentos.Anio}}</td>
                                        <td>{{Lista.TipoEstatusSolicitud.Nombre}}</td>
                                        <td v-if="UsuarioJuzgado.AreaAsignado.AreaId == 21">{{Lista.InventarioDocumentos.SedeArchivo.Nombre}}</td>
                                        <!-- <td >
                                            <i class="fas fa-eye" @click='DetallesVolumen(Lista)' title ="Ver Detalles de Solicitud"></i>
                                        </td> -->
                                        <td class="category_enabled text-center" v-if="Lista.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId == 2 && ChecaUbicacion(Lista) == true">
                                            <input v-model="Devoluciones" v-bind:value="Lista.SolicitudDocumentoId" type="checkbox" />
                                        </td>
                                        <td v-else></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <label class="label-black">Solicitudes seleccionadas para Devolución :  {{this.Devoluciones.length}}</label>
                        </div>
                    </div>
                        <div class="text-right">
                            <button class="btn btn-sm btn-custom" @click='Devolucion()' >Devolución de Solicitudes</button>
                        </div>
                </div>

            </div>
            <div v-if="this.Detalles==true">
                <Modal :Solicitudes="this.DatosEnvio" @dialogo='EstatusModalArchivo($event)'></Modal>
            </div>
        </div>
        <div class="row d-flex" v-if="AreaQueConsulta.Area.AreaId!=21 && AreaQueConsulta.Area.AreaId!=0">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 padding-div-low">
                <div class="area custom-area">
                    
                            <div class="form-group" id="Anio_div">
                                <label class="label-black">Fecha del Envío</label>
                                <input class="form-control" type="date" v-model="FechaEnvio"/>
                            </div>
                            <div id="VerificarFecha_div" class="text-right">
                                <button class="btn btn-sm btn-custom"  @click='VerificarFecha()'>Verificar Fecha de Listado</button>
                            </div>
                            <div class="form-group" id="Anio_div" v-if="Verificado==true && MostrarEnviar==true">
                                <label class="label-black">Código</label>
                                <input class="form-control" type="text" placeholder="Código del Documento" v-model="CodigoBarras" v-on:keyup.enter='DetectarEnter'/>
                            </div>
                            <div id="BotonBusqueda_div" class="text-right" v-if="Verificado==true && MostrarEnviar==true">
                                <button class="btn btn-sm btn-custom"  @click='CargaDocumento()'>Agregar Documento</button>
                            </div>
                            
                    
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low">
                <div class="area custom-area">
                    <div class="row" v-if="ListaArchivo.length>0 && MostrarEnviar==true">
                        <div class="form-group col-12 text-center">
                            <h6 class="label-black animado">No olvide guardar progreso y enviar listado de devueltos en la fecha programada</h6>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12 text-left">
                            <h5 class="label-black" v-if="ListaArchivo.filter(e=>e.Enviado == false).length>0">Total de Documentos para envío: {{this.ListaArchivo.length}}</h5>
                            <h5 class="label-black" v-else>Total de Documentos enviados en  {{this.FechaEnvio }}: {{this.ListaArchivo.length}}</h5>
                            <h6 class="label-black" v-if="ultimoAgregado!='' && ultimoAgregado!=null" > Ultimo agregado a lista: {{ultimoAgregado}}</h6>
                        </div>
                    </div>
                    
                        <div>
                            <div id="ListaArchivo_table" class="table-responsive">
                                <table class="table table-striped table-light table-hover table-sm">
                                    <thead class="thead-custom">
                                        <tr>
                                            <th>Tipo</th>
                                            <th>Consecutivo</th>
                                            <th>Juicio</th>
                                            <th>Partes</th>
                                            <!-- <th>Contenido</th> -->
                                            <th>Anexos</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-dark">
                                        <tr v-if="ListaArchivo.length <= 0">
                                            <td colspan="12" class="text-center">Sin Documentos para devolución al Archivo</td>
                                        </tr>
                                        <tr v-else v-for="Lista in ListaArchivo" :key="Lista.InventarioDocumentoId">
                                            <td width ="100" v-html="TipoDocumentoHTML(Lista)"></td>
                                            <td width= "30">{{Lista.Consecutivo}}/{{Lista.Anio}}</td>
                                            <td width= "150" v-html="DesglosaTipoJuicio(Lista)"></td>
                                            <td width= "400" v-html="DesglosaPartes(Lista.Partes)"></td>
                                            <!-- <td width= "200" v-html="DesglosaContenido(Lista)"></td> -->
                                            <!-- <td width= "350" v-if="Lista.Enviado!=null && Lista.Enviado==false"><input type="text" class="form-control" v-model="Lista.Anexos" v-on:keyup="enabledButton"></td> -->
                                            <td width="350">{{Lista.Anexos}}</td>
                                            <!-- <td width= "30" v-if="Lista.Enviado!=null && Lista.Enviado==false">
                                                <a v-on:click="agregarTomos(Lista)" title="Agregar Tomos">
                                                    <i class="fas fa-plus-circle"></i>
                                                </a>
                                            </td> -->
                                            <td width= "30">
                                                <a v-on:click="EditarAnexos(Lista)" title="Editar Observaciones / Anexos">
                                                    <i class="fas fa-pen-square"></i>
                                                </a>
                                            </td>
                                            <!-- <td width= "30" v-else>
                                            </td> -->
                                            <td width= "30" v-if="Lista.Enviado!=null && Lista.Enviado==false">
                                                <a v-on:click="EliminarDocumento(Lista)" title="Eliminar Documento de Lista">
                                                    <i class="fas fa-minus-circle"></i>
                                                </a>
                                            </td>
                                            <td width= "30" v-else>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br><br><br>
                        <div class="row">
                            <div class="form-group col-4 text-left">
                                <button v-if="ConteoInicial!=ListaArchivo.length || onGuardar==true" class="btn btn-sm btn-secondary" @click='GuardarLista(false)' >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Guardar Lista &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</button>
                            </div>
                            <div class="form-group col-4 text-center" >
                                <button id="btn_Enviar_archivo" v-if="MostrarEnviar==true && ListaArchivo.length>0" class="btn btn-sm btn-custom" @click='EnviarArchivo()' >&nbsp; &nbsp; Devolución al Archivo &nbsp; &nbsp;</button>
                            </div>
                            <div class="form-group col-4 text-right">
                                <button v-if="ListaArchivo.length>0" class="btn btn-sm btn-info" @click='AccionImprimirEnviar()' >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Imprimir Listado &nbsp; &nbsp; &nbsp; &nbsp;</button>
                            </div>
                        </div>
                        <div v-if="agregaTomos">
                            <Tomos :tomosActuales= this.Actuales :areaTomos= this.AreaQueConsulta :inventarioDocumento= this.InventarioId @dialogo='EstatusModal($event)'></Tomos>
                        </div>
                        <div v-if="modalAnexos">
                            <Anexos :inventarioDocumento= this.DocumentoModalAnexo @dialogo='EstatusAnexos($event)'></Anexos>
                        </div>
                </div>

            </div>
        </div>
    
        
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import ModalDetalles from '@/components/ArchivoJudicial/Comun/DetalleSolicitud.vue'
import LogoPJE from '@/../src/assets/Logotipo_Positivo_Vertical-recibo.png'
import FiltroDeBusqueda from '@/components/ArchivoJudicial/Comun/ConsultaDocumento.vue'
import addTomos from '@/../src/components/ArchivoJudicial/Comun/addTomos1aVez.vue'
import editAnexos from '@/../src/components/ArchivoJudicial/Comun/editAnexos.vue'

export default {
    components:{
      CAreas : catalogos.PJ.C001Area,
      Modal: ModalDetalles,
      Busqueda: FiltroDeBusqueda,
      Tomos: addTomos,
      Anexos: editAnexos
    }, 
    data(){
        return{
            enumeraciones,
            Detalles: false,
            BusquedaForm: {
                parametros_Area: {
                    areaId: -1
                }
            },
            ListaObtenida:[],
            Solicitudes: [],
            DatosEnvio: {},
            Devoluciones:[],
            UsuarioJuzgado :{
                AreaAsignado: {
                    AreaId:0,
                    Nombre: ""
                }
            },
            Filtro:null,
            AreaQueConsulta: {
                Area: {
                    AreaId: 0,
                    Nombre:""
                }
            },
            CodigoBarras: "",
            FechaEnvio: "",
            DocumentoObtenido: {},
            ListaCargada :[],
            ListaArchivo: [],
            ListaNuevos: [],
            ListaEliminados: [],
            Verificado: false,
            Actuales: 0,
            agregaTomos: false,
            InventarioId : 0,
            VolumenesRecibidos: false,
            IncidentesRecibidos: false,
            TerceriasRecibidos: false,
            ConteoInicial:0,
            onGuardar: false,
            MostrarEnviar :false,
            mostrarEdicion: false,
            modalAnexos: false,
            DocumentoModalAnexo : {},
            RegistroLista: false,
            ultimoAgregado : null,
            SecretariosAcuerdos :"",
            PuestoFirma : ""
        }
    },
    methods: {
        Codigo: function(e){
            if (e.keyCode==13)
            {
                if(this.Filtro.length==13)
                {
                    this.Solicitudes = this.ListaObtenida.filter(a=>a.InventarioDocumentos.CodigoBarras==this.Filtro);
                }
                else
                {
                    this.Solicitudes = this.ListaObtenida;
                    this.Solicitudes.sort((a,b)=>(a.InventarioDocumentos.CodigoBarras>b.InventarioDocumentos.CodigoBarras ? 1:-1));
                }
            }
        },
        cambioDeArea(datos){
            this.BusquedaForm.parametros_Area.areaId = parseInt(datos.target.value);
        },
        ObtenSolicitudes(){
            
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.SolicitudesActivas, null,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {   
                    this.ListaObtenida = respuesta.data.GetSolicitudes;
                    this.Solicitudes = this.ListaObtenida;

                    
                    this.Solicitudes.sort((a,b)=>(a.InventarioDocumentos.CodigoBarras>b.InventarioDocumentos.CodigoBarras ? 1:-1));
                    this.UsuarioJuzgado = respuesta.data.UsuarioJuzgado;
                    
                    this.$nextTick(()=> { PaginarTabla('Solicitudes_table', 20)});
                }
                comun.SeEstaCargandoInformacion(false);
                
                })
                .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
                
            })
        },
        DetallesVolumen: function(datos){
            this.DatosEnvio =  datos;
            this.Detalles = true;
        },
        EnviarArchivo: async function (){
            this.MostrarEnviar = false;
            await this.GuardarLista(true);
            if(this.RegistroLista==true)
            {
                comun.SeEstaCargandoInformacion(true);
                var MovimientosDocumentos =[];
                var SolicitudesAutorizadas = [];
                var SinRegistro = [];
                let EnvioFecha = moment(this.FechaEnvio).format('YYYY-MM-DD 08:00:00');
                let FechaEnObservaciones = moment(this.FechaEnvio).format('DD/MM/YYYY');
                var usrJuzgado = this.UsuarioJuzgado;
                $.each(this.ListaArchivo, function(indice, solicitud)
                {

                    $.each(solicitud.Volumenes, function (indice, volsId){
                                    if(volsId.MovimientoVolumen.SolicitudDocumentoId!=null)
                                    {
                                        var obtenerIdSolicitud = SolicitudesAutorizadas.find(e=>e.SolicitudDocumentoId == volsId.MovimientoVolumen.SolicitudDocumentoId);
                                        if(obtenerIdSolicitud == undefined || obtenerIdSolicitud == false)
                                        {
                                            SolicitudesAutorizadas.push({"SolicitudDocumentoId" : volsId.MovimientoVolumen.SolicitudDocumentoId, "TipoEstatusSolicitud" : {"TipoEstatusSolicitudDocumentoId": 3}})
                                        }

                                    }
                                    var idSolicitud = volsId.MovimientoVolumen.SolicitudDocumentoId;
                                    if(idSolicitud!=null)
                                    {
                                        MovimientosDocumentos.push({
                                            VolumenId : volsId.VolumenId,
                                            IncidenteId: null,
                                            TerceriaId: null,
                                            FechaMovimiento : EnvioFecha, //moment().format('YYYY-MM-DD HH:MM:SS'),
                                            TiposMovimientos: {"TipoMovimientoId": 7},
                                            UsuarioQuienPresta: {"IdUsuario" : usrJuzgado != null ? usrJuzgado.IdUsuario : null},
                                            UsuarioQuienRecibe: {"IdUsuario" : null},
                                            AreaQuePresta : {"AreaId" : usrJuzgado !=null ?  usrJuzgado.AreaAsignado.AreaId : null},
                                            AreaQueRecibe : {"AreaId" : enumeraciones.areasArchivo.General},
                                            SolicitudDocumentoId: idSolicitud, //volsId.MovimientoVolumen.SolicitudDocumentoId,
                                            Observaciones: "Movimiento de Documento en Devolución de prestamo con solicitud No. " +  idSolicitud + ", Fecha de Listado : " + FechaEnObservaciones
                                        });
                                    }
                                    else
                                    {
                                        SinRegistro.push({
                                        VolumenId : volsId.VolumenId,
                                        IncidenteId: null,
                                        TerceriaId: null,
                                        FechaMovimiento : EnvioFecha, //moment().format('YYYY-MM-DD HH:MM:SS'),
                                        TiposMovimientos: {"TipoMovimientoId": 7},
                                        UsuarioQuienPresta: {"IdUsuario" : usrJuzgado != null ? usrJuzgado.IdUsuario : null},
                                        UsuarioQuienRecibe: {"IdUsuario" : null},
                                        AreaQuePresta : {"AreaId" : usrJuzgado !=null ?  usrJuzgado.AreaAsignado.AreaId : null},
                                        AreaQueRecibe : {"AreaId" : enumeraciones.areasArchivo.General},
                                        SolicitudDocumentoId: null,
                                        Observaciones: "Movimiento de Documento en Devolución de prestamo no registrado en sistema" + ", Fecha de Listado : " + FechaEnObservaciones
                                    });
                                    }
                                    
                                    // if(volsId.Volumenes.Amparos!= null && volsId.Volumenes.Amparos.length>0)
                                    // {
                                    //     $.each(volsId.Volumenes.Amparos, function (id, amparo)
                                    //     {
                                    //         MovimientosDocumentos.push({
                                    //             VolumenId : amparo.AmparosDelDocumento.Volumenes[0].VolumenId,
                                    //             IncidenteId: null,
                                    //             TerceriaId: null,
                                    //             FechaMovimiento : EnvioFecha, //moment().format('YYYY-MM-DD HH:MM:SS'),
                                    //             TiposMovimientos: {"TipoMovimientoId": 1},
                                    //             UsuarioQuienPresta: {"IdUsuario" : usrJuzgado != null ? usrJuzgado.IdUsuario : null},
                                    //             UsuarioQuienRecibe: {"IdUsuario" : null},
                                    //             AreaQuePresta : {"AreaId" : usrJuzgado !=null ?  usrJuzgado.AreaAsignado.AreaId : null},
                                    //             AreaQueRecibe : {"AreaId" : enumeraciones.areasArchivo.General},
                                    //             SolicitudDocumentoId: solicitud.SolicitudDocumentoId,
                                    //             Observaciones: solicitud.SolicitudDocumentoId !=null ? ("Movimiento de Documento en Devolución de prestamo con solicitud No. " + solicitud.SolicitudDocumentoId) : "Movimiento de Documento en Devolución de prestamo no registrado en sistema."
                                    //         });
                                    //     })
                                    // }

                                });                                         
                    $.each(solicitud.Incidentes, function (indice, volsId){
                        
                        if(volsId.MovimientoIncidente.SolicitudDocumentoId!=null)
                        {
                            var obtenerIdSolicitud = SolicitudesAutorizadas.find(e=>e.SolicitudDocumentoId == volsId.MovimientoIncidente.SolicitudDocumentoId);
                            if(obtenerIdSolicitud == undefined || obtenerIdSolicitud == false)
                            {
                                SolicitudesAutorizadas.push({"SolicitudDocumentoId" : volsId.MovimientoIncidente.SolicitudDocumentoId, "TipoEstatusSolicitud" : {"TipoEstatusSolicitudDocumentoId": 3}})
                            }
                        }  
                        var idSolicitud = volsId.MovimientoIncidente.SolicitudDocumentoId;       
                        if(idSolicitud!=null) 
                        {
                            MovimientosDocumentos.push({
                                        VolumenId : null,
                                        IncidenteId: volsId.IncidenteId,
                                        TerceriaId: null,
                                        FechaMovimiento : EnvioFecha, //moment(this.FechaEnvio).format('YYYY-MM-DD'),
                                        TiposMovimientos: {"TipoMovimientoId": 7},
                                        UsuarioQuienPresta: {"IdUsuario" : usrJuzgado != null ? usrJuzgado.IdUsuario : null},
                                        UsuarioQuienRecibe: {"IdUsuario" : null},
                                        AreaQuePresta : {"AreaId" : usrJuzgado !=null ?  usrJuzgado.AreaAsignado.AreaId : null},
                                        AreaQueRecibe : {"AreaId" : enumeraciones.areasArchivo.General},
                                        SolicitudDocumentoId: idSolicitud,
                                        Observaciones: "Movimiento de Documento en Devolución de prestamo con solicitud No. " + idSolicitud + ", Fecha de Listado : " + FechaEnObservaciones
                            });
                        }
                        else
                        {
                            SinRegistro.push({
                                VolumenId : null,
                                        IncidenteId: volsId.IncidenteId,
                                        TerceriaId: null,
                                        FechaMovimiento : EnvioFecha, //moment(this.FechaEnvio).format('YYYY-MM-DD'),
                                        TiposMovimientos: {"TipoMovimientoId": 7},
                                        UsuarioQuienPresta: {"IdUsuario" : usrJuzgado != null ? usrJuzgado.IdUsuario : null},
                                        UsuarioQuienRecibe: {"IdUsuario" : null},
                                        AreaQuePresta : {"AreaId" : usrJuzgado !=null ?  usrJuzgado.AreaAsignado.AreaId : null},
                                        AreaQueRecibe : {"AreaId" : enumeraciones.areasArchivo.General},
                                        SolicitudDocumentoId: null,
                                        Observaciones:  "Movimiento de Documento en Devolución de prestamo no registrado en sistema" + ", Fecha de Listado : " + FechaEnObservaciones
                            });
                        } 
                                    
                    });
                    $.each(solicitud.Tercerias, function (indice, volsId){
                        if(volsId.MovimientoTerceria.SolicitudDocumentoId!=null)
                        {
                            var obtenerIdSolicitud = SolicitudesAutorizadas.find(e=>e.SolicitudDocumentoId == volsId.MovimientoTerceria.SolicitudDocumentoId);
                            if(obtenerIdSolicitud == undefined || obtenerIdSolicitud == false)
                            {
                                SolicitudesAutorizadas.push({"SolicitudDocumentoId" : volsId.MovimientoTerceria.SolicitudDocumentoId, "TipoEstatusSolicitud" : {"TipoEstatusSolicitudDocumentoId": 3}})
                            }
                        }
                        var solicitudId = volsId.MovimientoTerceria.SolicitudDocumentoId;
                        if(solicitudId!=null) 
                        {
                            MovimientosDocumentos.push({
                                        VolumenId : null,
                                        IncidenteId: null,
                                        TerceriaId: volsId.TerceriaId,
                                        FechaMovimiento : EnvioFecha, //moment().format('YYYY-MM-DD HH:MM:SS'),
                                        TiposMovimientos: {"TipoMovimientoId": 7},
                                        UsuarioQuienPresta: {"IdUsuario" : usrJuzgado != null ? usrJuzgado.IdUsuario : null},
                                        UsuarioQuienRecibe: {"IdUsuario" : null},
                                        AreaQuePresta : {"AreaId" : usrJuzgado !=null ?  usrJuzgado.AreaAsignado.AreaId : null},
                                        AreaQueRecibe : {"AreaId" : enumeraciones.areasArchivo.General},
                                        SolicitudDocumentoId: solicitudId,
                                        Observaciones: "Movimiento de Documento en Devolución de prestamo con solicitud No. " + solicitudId + ", Fecha de Listado : " + FechaEnObservaciones
                                    });
                        }
                        else
                        {
                            SinRegistro.push({
                                VolumenId : null,
                                        IncidenteId: null,
                                        TerceriaId: volsId.TerceriaId,
                                        FechaMovimiento : EnvioFecha, //moment().format('YYYY-MM-DD HH:MM:SS'),
                                        TiposMovimientos: {"TipoMovimientoId": 7},
                                        UsuarioQuienPresta: {"IdUsuario" : usrJuzgado != null ? usrJuzgado.IdUsuario : null},
                                        UsuarioQuienRecibe: {"IdUsuario" : null},
                                        AreaQuePresta : {"AreaId" : usrJuzgado !=null ?  usrJuzgado.AreaAsignado.AreaId : null},
                                        AreaQueRecibe : {"AreaId" : enumeraciones.areasArchivo.General},
                                        SolicitudDocumentoId: null,
                                        Observaciones: "Movimiento de Documento en Devolución de prestamo no registrado en sistema" + ", Fecha de Listado : " + FechaEnObservaciones
                            })
                        }        
                                    
                    });           
                });
                let peticion = {
                    SolicitudesAutorizadas,
                    MovimientosDocumentos,
                    SinRegistro
                };
                
                axios.post(api.conexion + api.ArchivoJudicial.CambiaEstadoSolicitud, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                        ).then(respuesta => {
                            if(respuesta.data.SiHayError)
                                {
                                    console.log(respuesta);
                                    comun.SeEstaCargandoInformacion(false);
                                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                                }
                            else
                                {   
                                    comun.SeEstaCargandoInformacion(false);
                                    // this.ListaArchivo =[];
                                    // this.VerificarFecha();
                                    
                                    comun.mensajeDeAlerta('Se Generado la Devolución de los documentos en prestamos', null, null);
                                    var temporal = this.ListaArchivo;
                                    this.ListaArchivo= []
                                    $.each(temporal, function(id, elemento)
                                    {
                                        elemento.Enviado=true;
                                    });
                                    this.ListaArchivo = temporal;
                                }
                            comun.SeEstaCargandoInformacion(false);
                        }).catch(excepcion => {
                            console.log(excepcion);
                            comun.SeEstaCargandoInformacion(false);
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        });
            } 
            else 
            {
                comun.mensajeDeAlerta('Ocurrio un error al registrar y enviar lista de devueltos, intente nuevamente', null, null);
            }        
        },
        Devolucion: function(solicitud){
            comun.SeEstaCargandoInformacion(true);
            let SolicitudesAutorizadas =  this.SeleccionSolicitudes();
            if(SolicitudesAutorizadas.length > 0)
            {
                    var usrJuzgado = this.UsuarioJuzgado;
                    var EstatusSolicitud = 0
                    var MovimientosDocumentos =[];
                    $.each(SolicitudesAutorizadas, function(indice, solicitud)
                    {
                        if(solicitud.Juzgado==null)
                        {
                            usrJuzgado = null
                        }

                        $.each(solicitud.VolumenesEnSolicitud, function (indice, volsId){
                                
                                MovimientosDocumentos.push({
                                    VolumenId : volsId.VolumenId,
                                    IncidenteId: volsId.IncidenteId,
                                    TerceriaId: volsId.TerceriaId,
                                    FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                                    TiposMovimientos: {"TipoMovimientoId": 7},
                                    UsuarioQuienPresta: {"IdUsuario" : usrJuzgado != null ? usrJuzgado.IdUsuario : null},
                                    UsuarioQuienRecibe: {"IdUsuario" : null},
                                    AreaQuePresta : {"AreaId" : usrJuzgado !=null ?  usrJuzgado.AreaAsignado.AreaId : null},
                                    AreaQueRecibe : {"AreaId" : enumeraciones.areasArchivo.General},
                                    SolicitudDocumentoId: solicitud.SolicitudDocumentoId,
                                    Observaciones: "Movimiento de Documento en Devolución de prestamo con solicitud No. " + solicitud.SolicitudDocumentoId
                                });
                                if(volsId.Volumenes.Amparos!= null && volsId.Volumenes.Amparos.length>0)
                                {
                                    $.each(volsId.Volumenes.Amparos, function (id, amparo)
                                    {
                                        MovimientosDocumentos.push({
                                            VolumenId : amparo.AmparosDelDocumento.Volumenes[0].VolumenId,
                                            IncidenteId: null,
                                            TerceriaId: null,
                                            FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                                            TiposMovimientos: {"TipoMovimientoId": 7},
                                            UsuarioQuienPresta: {"IdUsuario" : usrJuzgado != null ? usrJuzgado.IdUsuario : null},
                                            UsuarioQuienRecibe: {"IdUsuario" : null},
                                            AreaQuePresta : {"AreaId" : usrJuzgado !=null ?  usrJuzgado.AreaAsignado.AreaId : null},
                                            AreaQueRecibe : {"AreaId" : enumeraciones.areasArchivo.General},
                                            SolicitudDocumentoId: solicitud.SolicitudDocumentoId,
                                            Observaciones: "Movimiento de Documento en Devolución de prestamo con solicitud No. " + solicitud.SolicitudDocumentoId 
                                        });
                                    })
                                }

                            });       
                        $.each(solicitud.IncidentesEnSolicitud, function (indice, volsId){
                                
                                MovimientosDocumentos.push({
                                    VolumenId : volsId.VolumenId,
                                    IncidenteId: volsId.IncidenteId,
                                    TerceriaId: volsId.TerceriaId,
                                    FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                                    TiposMovimientos: {"TipoMovimientoId": 7},
                                    UsuarioQuienPresta: {"IdUsuario" : usrJuzgado != null ? usrJuzgado.IdUsuario : null},
                                    UsuarioQuienRecibe: {"IdUsuario" : null},
                                    AreaQuePresta : {"AreaId" : usrJuzgado !=null ?  usrJuzgado.AreaAsignado.AreaId : null},
                                    AreaQueRecibe : {"AreaId" : enumeraciones.areasArchivo.General},
                                    SolicitudDocumentoId: solicitud.SolicitudDocumentoId,
                                    Observaciones: "Movimiento de Documento en Devolución de prestamo con solicitud No. " + solicitud.SolicitudDocumentoId
                                });
                            });
                        $.each(solicitud.TerceriasEnSolicitud, function (indice, volsId){
                                
                                MovimientosDocumentos.push({
                                    VolumenId : volsId.VolumenId,
                                    IncidenteId: volsId.IncidenteId,
                                    TerceriaId: volsId.TerceriaId,
                                    FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                                    TiposMovimientos: {"TipoMovimientoId": 7},
                                    UsuarioQuienPresta: {"IdUsuario" : usrJuzgado != null ? usrJuzgado.IdUsuario : null},
                                    UsuarioQuienRecibe: {"IdUsuario" : null},
                                    AreaQuePresta : {"AreaId" : usrJuzgado !=null ?  usrJuzgado.AreaAsignado.AreaId : null},
                                    AreaQueRecibe : {"AreaId" : enumeraciones.areasArchivo.General},
                                    SolicitudDocumentoId: solicitud.SolicitudDocumentoId,
                                    Observaciones: "Movimiento de Documento en Devolución de prestamo con solicitud No. " + solicitud.SolicitudDocumentoId 
                                });
                            });           
                        });

                    let peticion = {
                        SolicitudesAutorizadas,
                        MovimientosDocumentos
                        };
                   
                    
                    axios.post(api.conexion + api.ArchivoJudicial.CambiaEstadoSolicitud, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                    ).then(respuesta => {
                        if(respuesta.data.SiHayError)
                            {
                                console.log(respuesta);
                                comun.SeEstaCargandoInformacion(false);
                                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            }
                        else
                            {   
                                comun.SeEstaCargandoInformacion(false);
                                comun.mensajeDeAlerta("Se Generado la Devolución de los documentos en prestamos", null, null);
                                this.ObtenSolicitudes();
                                this.Devoluciones=[];
                            }
                        comun.SeEstaCargandoInformacion(false);
                    }).catch(excepcion => {
                        console.log(excepcion);
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    });
            }
            else {
                comun.mensajeDeAlerta("Seleccione Solicitudes para Devolución", null, null);
            }
            
        },
        EstatusModalArchivo(valor){
            this.Detalles = valor;
        },
        ChecaUbicacion(volumen){
            var UsuarioActual = this.UsuarioJuzgado.IdUsuario;
            var Conteo = 0;
            if(volumen.Juzgado !=null)
            {
                $.each(volumen.VolumenesEnSolicitud, function(index, listado)
                {
                    // if(listado.Volumenes.MovimientoVolumen.UsuarioQuienRecibe.IdUsuario != UsuarioActual)
                    // {
                    //     Conteo =+1;
                    // }
                    //else{
                        if(listado.Volumenes.MovimientoVolumen.FechaRecepcion == null || listado.Volumenes.MovimientoVolumen.FechaRecepcion =="" )
                        {
                            Conteo =+1;
                        }
                    //}
                });
                if (Conteo == 0)
                {
                    return true;
                }
                else{
                    return false;
                }
            }
            else
            {
                return true;
            }
            
        },
        SeleccionSolicitudes(){
            let solicitudesSeleccionadas = [];
            this.Devoluciones.forEach((element) =>{
                let agregaSolicitud = this.Solicitudes.find(sol=>sol.SolicitudDocumentoId == element);
                if(agregaSolicitud.Juzgado!= null)
                {
                    agregaSolicitud.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId = 3;
                }
                else{
                    agregaSolicitud.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId = 4;
                }
                
                solicitudesSeleccionadas.push(agregaSolicitud);
            });
            return solicitudesSeleccionadas;
        },
        GenerarPrint: function(Listado){
            let _this = this;
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">LISTADO DE DOCUMENTOS EN SOLICITUD EN DEVOLUCIÓN</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h6 class="text-center">RECEPCIÓN DE DOCUMENTOS</h6>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 text-right">');
            printWin.document.write('<label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 ">');
            printWin.document.write('<label>Area: '+ this.AreaQueConsulta.Area.Nombre +'</label>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12">');
            printWin.document.write('<div class="table-reponsive">');
            printWin.document.write('<table class="table table-striped table-light table-hover style="page-break-before: auto;">');
            printWin.document.write('<thead class="thead-dark" style="display:table-header-group"><tr><th >Solicitud No.</th><th >Documento</th><th >Consecutivo</th>');
            printWin.document.write('<th>Contenido</th></tr></thead><tbody class="text-dark">');
            //ciclo inicio
            $.each(Listado, function(index, SolicitudesImpresion){

                                
                printWin.document.write('<tr style="page-break-inside:avoid; page-break-after:auto">');
                printWin.document.write('<td >'+ SolicitudesImpresion.SolicitudDocumentoId +'</td>');
                printWin.document.write('<td >'+ SolicitudesImpresion.InventarioDocumentos.TipoDocumento.Nombre +'</td>');
                printWin.document.write('<td >'+ SolicitudesImpresion.InventarioDocumentos.Consecutivo +'/' + SolicitudesImpresion.InventarioDocumentos.Anio +'</td>');
                printWin.document.write('<td >'+ _this.DesglosaParaImpresion(SolicitudesImpresion) +'</td>');
                printWin.document.write('</tr>');
            });
            //ciclo fin

            printWin.document.write('</tbody></table></div></div></div>');
            printWin.document.write('<div class="area" style="page-break-inside: avoid; page-break-after: auto">');
            
                        printWin.document.write('<div class="row">');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>Nombre Completo</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + this.AreaQueConsulta.Area.Nombre + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-2"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>Nombre Completo</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>Archivo Judicial</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('</div>');


            printWin.document.write('</div>');
            printWin.document.write('</div>');

            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        DesglosaParaImpresion: function (datos) {
            let Contenido ="";
            if(datos.VolumenesEnSolicitud.length>0)
                {   
                    $.each(datos.VolumenesEnSolicitud, function(index, Listado)
                        {
                            Contenido = Contenido + "<b class='text-white bg-dark'>VOLUMEN NO.</b> " + Listado.Volumenes.NumVolumen + "<br/>"
                        });
                };
            if(datos.IncidentesEnSolicitud!=null && datos.IncidentesEnSolicitud.length>0)
            {
                $.each(datos.IncidentesEnSolicitud, function(index, Listado)
                {
                    Contenido = Contenido + "<b class='text-white bg-dark'>INCIDENTE</b>"+ Listado.Incidentes.NumeroIncidente+ "<br/>"
                });
            }
            if(datos.TerceriasEnSolicitud!=null && datos.TerceriasEnSolicitud.length>0)
            {
                
                $.each(datos.TerceriasEnSolicitud, function(index, enVolumen)
                {
                    Contenido = Contenido + "<b class='text-white bg-dark'>TERCERIAS</b>" + enVolumen.Tercerias.NumeroTerceria + "<br/>";
                    
                })
            }
            return Contenido;
        },
        CargaDocumento(){
            this.VolumenesRecibidos=false;
            this.TerceriasRecibidos=false;
            this.IncidentesRecibidos= false;
            if(this.ChecaCodigo(this.CodigoBarras) == true)
            {
                if(this.VerificaEnListado()==false)
                {
                    var peticion = {
                        "AreaId": -1,
                        "TipoDocumentoId" : -1,
                        "Anio" : null,
                        "Consecutivo": null,
                        "CodigoBarras": this.CodigoBarras.trim(),
                        "Archivo": true
                            };
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(api.conexion + api.ArchivoJudicial.ObtenerDocumento, peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                    if(respuesta.data.SiHayError)
                    {
                        comun.SeEstaCargandoInformacion(false);
                        this.CodigoBarras =null;
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                    else
                        {   
                            let _this = this;
                            let pendientes = [];
                            comun.SeEstaCargandoInformacion(false);
                            this.DocumentoObtenido = respuesta.data.GetDocumento;
                            if(this.DocumentoObtenido.Volumenes.length>0)
                            {
                                $.each(_this.DocumentoObtenido.Volumenes, function(id, tomo){
                                    if(tomo.MovimientoVolumen!=null && tomo.MovimientoVolumen.FechaRecepcion==null)
                                    {
                                        _this.VolumenesRecibidos = true;
                                        let UsuarioNombre = tomo.MovimientoVolumen.UsuarioQuienRecibe!=null ? (tomo.MovimientoVolumen.UsuarioQuienRecibe.Nombre  + " " + tomo.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno) : tomo.MovimientoVolumen.AreaQueRecibe.Nombre;
                                        pendientes.push({"Elemento": "Tomo", "Numero": tomo.NumVolumen, "Usuario": UsuarioNombre})
                                    }
                                })
                            };
                            if(this.DocumentoObtenido.Incidentes.length>0)
                            {
                                $.each(_this.DocumentoObtenido.Incidentes, function(id, incidente){
                                    if(incidente.MovimientoIncidente!=null && incidente.MovimientoIncidente.FechaRecepcion==null)
                                    {
                                        _this.IncidentesRecibidos = true;
                                        let UsuarioNombre = incidente.MovimientoIncidente.UsuarioQuienRecibe!=null ? (incidente.MovimientoIncidente.UsuarioQuienRecibe.Nombre  + " " + incidente.MovimientoIncidente.UsuarioQuienRecibe.ApellidoPaterno) : incidente.MovimientoIncidente.AreaQueRecibe.Nombre;
                                        pendientes.push({"Elemento": "Incidente", "Numero": incidente.NumeroIncidente, "Usuario": UsuarioNombre})
                                    }
                                })
                            };
                            if(this.DocumentoObtenido.Tercerias.length>0)
                            {
                                $.each(_this.DocumentoObtenido.Tercerias, function(id, terceria){
                                    if(terceria.MovimientoTerceria!=null && terceria.MovimientoTerceria.FechaRecepcion==null)
                                    {
                                        _this.TerceriasRecibidos = true;
                                        let UsuarioNombre = terceria.MovimientoTerceria.UsuarioQuienRecibe!=null ? (terceria.MovimientoTerceria.UsuarioQuienRecibe.Nombre  + " " + terceria.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno) : terceria.MovimientoTerceria.AreaQueRecibe.Nombre;
                                        pendientes.push({"Elemento": "Terceria", "Numero": terceria.NumeroTerceria, "Usuario": UsuarioNombre})
                                    }
                                })
                            };

                            if(this.VolumenesRecibidos==false && this.TerceriasRecibidos==false && this.IncidentesRecibidos== false)
                            {
                                if(this.DocumentoObtenido.FechaRegistroArchivo!=null)
                                {
                                    this.VerificaDocumento(this.DocumentoObtenido); 
                                    this.MostrarEnviar ==true;
                                }
                                else
                                {
                                    comun.mensajeDeAlerta("Este documento no correponde a un prestamo vigente con Archivo Judicial", null, null);
                                }  
                            }
                            else
                            {
                                var mensaje = '<label class="text-danger">Este documento tiene una recepción pendiente</label>' + '<br>';
                                if(pendientes.length>0)
                                {
                                    $.each(pendientes, function(id, elemento){
                                        mensaje= mensaje + elemento.Elemento + " " + elemento.Numero + " pendiente por: " + elemento.Usuario + '<br>'
                                    });
                                    //mensaje = mensaje + "Para poder agregar este documento a la lista de Archivo, generar recepción del mismo."
                                }
                                comun.mensajeDeAlerta(mensaje, null, null);
                            };
                                     
                    }
                    comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros");
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                    });
                }
                else 
                {
                    comun.mensajeDeAlerta("Documento previamente Registrado en el Listado para Envío", null, null);
                }
            };
            this.CodigoBarras = null;
            this.DocumentoObtenido = null;
        },
        VerificarFecha(){
            // this.ListaArchivo=[];
            // this.MostrarEnviar=false;
            // var AreaId = this.AreaQueConsulta.Area.AreaId;
            // let _this =this;
            let _this =this;
            this.ListaCargada = [];
            this.MostrarEnviar = false;
            this.ListadoArchivo = [];
            this.ListaEliminados = [];
            this.ListadoAgregar = [];
            var AreaId = this.AreaQueConsulta.Area.AreaId;
            this.ultimoAgregado="";
            if(this.FechaEnvio!= null && this.FechaEnvio!="")
            {
             var peticion = {"AreaId": AreaId, "FechaEnvio": this.FechaEnvio, "Devueltos" : true};
             comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.VerificarFechaListado, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                if(respuesta.data.SiHayError)
                    {
                        comun.SeEstaCargandoInformacion(false);
                        
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                else
                    {   $('#navListaArchivo_table').remove();
                            comun.SeEstaCargandoInformacion(false);
                            this.ConteoInicial = respuesta.data.ListadosArchivo!=null ? respuesta.data.ListadosArchivo.length : 0;
                            if(this.ConteoInicial == 0)
                            {
                                comun.mensajeDeAlerta("No Existe lista preeviamente registrada para esta fecha", null, null);
                            }
                            var ListadoObtenido = respuesta.data.ListadosArchivo!=null ? respuesta.data.ListadosArchivo :[];
                            this.ListaCargada = respuesta.data.ListadosArchivo!=null ? respuesta.data.ListadosArchivo :[];
                            this.UsuarioJuzgado = respuesta.data.Usuario;
                            var secretario = respuesta.data.SecretarioAcuerdos;
                            var opcion2 =respuesta.data.SecretariosAcuerdos;
                            if(secretario=="")
                            {
                                
                                if(opcion2.length>0)
                                {
                                    this.SecretariosAcuerdos = opcion2[0];
                                }
                                else
                                {
                                    this.SecretariosAcuerdos = "NOMBRE Y FIRMA";
                                }
                            }
                            else
                            {
                                this.SecretariosAcuerdos = secretario;
                                this.PuestoFirma = respuesta.data.PuestoFirma
                            }
                            

                            var FormatoLista = [];
                            $.each(ListadoObtenido, function(index, lista)
                            {
                                lista.InventarioDocumentos.Enviado = lista.Enviado;
                                FormatoLista.push(lista.InventarioDocumentos);
                            })
                            this.ListaArchivo = FormatoLista.sort(this.sortAnioConsecutivo);;
                            this.Verificado = true;
                            let contadorNoEnviados = this.ListaArchivo.filter(e=>e.Enviado == false).length;
                            let contadorObtenidos =this.ListaArchivo.length
                            this.$nextTick(()=> { PaginarTabla('ListaArchivo_table', 10)});
                            
                            if(contadorNoEnviados== contadorObtenidos)
                            {
                                this.MostrarEnviar=true;
                                this.mostrarEdicion = false;
                            }
                            else
                            {
                                this.MostrarEnviar=false;
                                this.mostrarEdicion =true;
                            };
                        comun.SeEstaCargandoInformacion(false);
                    }
                    
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros");
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                    });

            }
            else
            {
                comun.mensajeDeAlerta("Defina Fecha Valida para Verificar Listado", null, null);
            }
        },
        GuardarLista : async function(envio){
            let _this = this;
            var ListadoArchivo=[];
            var ListadoAgregar = [];
            var ListadoBorrar = this.ListaEliminados;
            let AreaEnvio = this.AreaQueConsulta.Area
            let Fecha = this.FechaEnvio;
            var Temporal = [];
            if(envio==false)
            {
                comun.SeEstaCargandoInformacion(true);
            }
            // var ListadoArchivo=[];
            // var AreaEnvio = this.AreaQueConsulta.Area
            // var Fecha = this.FechaEnvio;
            if(this.ListaArchivo.length>0 || envio==true)
            {
                if(this.ListaCargada.length==0)
                {
                    Temporal = this.ListaArchivo
                };
                
                if(envio==true)
                {
                    ListadoArchivo = this.ListaCargada;
                };
                if(Temporal.length>0)
                {
                    $.each(Temporal, function(index, lista)
                    {
                        ListadoArchivo.push({
                            "Area": AreaEnvio,
                            "FechaEnvio": Fecha,
                            "InventarioDocumentoId": lista.InventarioDocumentoId,
                            "Enviado": envio==true ? true : false,
                            "Devolucion": true,
                            "Anexos": lista.Anexos
                        })
                    });
                };
                $.each(this.ListaNuevos, function(index, lista)
                {
                    ListadoAgregar.push({
                        "Area": AreaEnvio,
                        "FechaEnvio": Fecha,
                        "InventarioDocumentoId": lista.InventarioDocumentoId,
                        "Enviado": envio==true ? true : false,
                        "Devolucion": true,
                        "Anexos": lista.Anexos
                    })
                });
                var peticion = {ListadoArchivo, ListadoAgregar, ListadoBorrar, "AreaId": AreaEnvio.AreaId, "FechaEnvio": Fecha, "Devueltos": true};
                var header = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);
                const Resultado = await axios.post(api.conexion + api.ArchivoJudicial.GuardarListadoArchivo, peticion, header );
                if (Resultado.data.SiHayError)
                {
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(Resultado.data.Error.Mensaje, null, null);
                    this.RegistroLista = false
                }
                else
                {
                            if(envio==false)
                            {
                                comun.mensajeDeAlerta("Se han Registrado los Cambios en la Lista", null, null);
                                comun.SeEstaCargandoInformacion(false);
                                this.VerificarFecha();
                            }
                            this.ConteoInicial = this.ListaArchivo.length;
                            this.RegistroLista = true;
                            this.onGuardar=false
                }
            }
            if(this.ListaArchivo.length==0 && envio==false)
            {
                var peticion = {ListadoArchivo, ListadoAgregar, ListadoBorrar, "AreaId": AreaEnvio.AreaId, "FechaEnvio": Fecha, "Devueltos": true};
                var header = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);
                const Resultado = await axios.post(api.conexion + api.ArchivoJudicial.GuardarListadoArchivo, peticion, header);
                if (Resultado.data.SiHayError)
                {
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(Resultado.data.Error.Mensaje, null, null);
                    this.RegistroLista = false
                }
                else
                {
                            if(envio==false)
                            {
                                comun.mensajeDeAlerta("Se han Registrado los Cambios en la Lista", null, null);
                                comun.SeEstaCargandoInformacion(false);
                                this.VerificarFecha();
                            }
                            this.ConteoInicial = this.ListaArchivo.length;
                            this.RegistroLista = true;
                            this.onGuardar=false
                }
                comun.SeEstaCargandoInformacion(false);
            }
        },
        VerificaDocumento(documento){
            documento.Enviado = false;
            var ElementoFueraDeArea = {
                "Volumenes": [],
                "Incidentes": [],
                "Tercerias": []
            };
            var EnSolicitud= false;
            var Area= this.AreaQueConsulta.Area.AreaId;
            if(documento.Volumenes.length>0)
            {
                $.each(documento.Volumenes, function(index, listaVolumenes){
                    if(listaVolumenes.Area.AreaId!=Area)
                    {
                        ElementoFueraDeArea.Volumenes.push(listaVolumenes);
                    };
                });
            }
            if(documento.Incidentes.length>0)
            {
                $.each(documento.Incidentes, function(index, listaIncidentes){
                    if(listaIncidentes.Area.AreaId!=Area)
                    {
                        ElementoFueraDeArea.Incidentes.push(listaIncidentes);
                    };
                });
            }
            if(documento.Tercerias.length>0)
            {
                $.each(documento.Tercerias, function(index, listaTercerias){
                     if(listaTercerias.Area.AreaId!=Area)
                    {
                        ElementoFueraDeArea.Tercerias.push(listaTercerias);
                    };
                });
            }
            
            if(ElementoFueraDeArea.Volumenes.length == 0 && ElementoFueraDeArea.Incidentes.length==0 && ElementoFueraDeArea.Tercerias.length==0)
            {
                    //Aqui Verificar si es Prestamo del Archivo
                    if (this.ListaCargada.length>0)
                    {
                        this.ListaNuevos.push(documento)
                    }
                    $('#navListaArchivo_table').remove();
                    this.ListaArchivo.push(documento);
                    this.ListaArchivo.sort((a,b)=>(a.CodigoBarras>b.CodigoBarras ? 1:-1));
                
                    if(this.ListaArchivo.length>10)
                    {
                        this.$nextTick(()=> { PaginarTabla('ListaArchivo_table', 15)});
                    };
                    this.ultimoAgregado = this.TipoDocumentoHTML(documento) + " " + documento.Consecutivo + "/" + documento.Anio
            }
            else
            { 
                var mensaje= "";
                $.each(ElementoFueraDeArea.Volumenes, function(index, lista)
                {   if(lista.MovimientoVolumen!=null)
                    {
                        mensaje = mensaje + "Tomo # " + lista.NumVolumen + " en " + lista.MovimientoVolumen.AreaQueRecibe.Nombre + "<br>";
                    }
                    else {
                        mensaje = mensaje + "Tomo # " + lista.NumVolumen + " en Archivo General<br>";
                    }
                     
                });
                $.each(ElementoFueraDeArea.Incidentes, function(index, lista)
                {
                    if(lista.MovimientoIncidente!=null)
                    {
                        mensaje = mensaje + "Incidente fuera de cuerdas # " + lista.NumeroIncidente + " en " + lista.MovimientoIncidente.AreaQueRecibe.Nombre + "<br>";
                    }
                    else
                    {
                        mensaje = mensaje + "Incidente fuera de cuerdas # " + lista.NumeroIncidente + " en Archivo General<br>";
                    }
                    
                });
                $.each(ElementoFueraDeArea.Tercerias, function(index, lista)
                {
                    if(lista.MovimientoTerceria!=null)
                    {
                        mensaje = mensaje + "Terceria # " + lista.NumeroTerceria + " en " + lista.MovimientoTerceria.AreaQueRecibe.Nombre + "<br>";
                    }
                    else
                    {
                        mensaje = mensaje + "Terceria # " + lista.NumeroTerceria + " en Archivo General<br>";
                    }
                    
                });
                comun.mensajeDeAlerta("Verifique la Ubicación de: <br>" + mensaje, null, null);
                   
            }
            
        },
        ChecaCodigo: function(codigo){
            var AreaDelCodigo = parseInt(codigo.substr(0,2));

            if(AreaDelCodigo == this.AreaQueConsulta.Area.AreaId || AreaDelCodigo == this.AreaQueConsulta.Area.AreaArchivoId)
            {
                switch(codigo.length)
                {
                    case 13:
                        var Estatus = !isNaN(parseFloat(codigo)) && isFinite(codigo);
                        if(Estatus ==false)
                        {
                            comun.mensajeDeAlerta("El Código debe contener caracteres númericos", null, null);
                        }
                        return Estatus;
                        break;
                    case 14:
                        var boleanoNumerico = false;
                        var boleanoRomano = false;
                        var numerico = codigo.substr(0,13);
                        var Romano = codigo.substr(13,1);
                        boleanoNumerico = !isNaN(parseFloat(numerico)) && isFinite(numerico);
                        if(Romano!= "I")
                        {
                        boleanoRomano =false
                        }
                        else
                        {
                        boleanoRomano=true;
                        }
                        if(boleanoNumerico==true && boleanoRomano==true)
                        {return true}
                        else 
                        {
                            comun.mensajeDeAlerta("Error el Código del Documento", null, null);
                            return false;}
                        break;
                    case 15:
                        var boleanoNumerico = false;
                        var boleanoRomano = false;
                        var numerico = codigo.substr(0,13);
                        var Romano = codigo.substr(13,2);
                        boleanoNumerico = !isNaN(parseFloat(numerico)) && isFinite(numerico);
                        if(Romano!= "II")
                        {
                        boleanoRomano =false
                        }
                        else
                        {
                        boleanoRomano=true;
                        }
                        if(boleanoNumerico==true && boleanoRomano==true)
                        {return true}
                        else 
                        {
                            comun.mensajeDeAlerta("Error el Código del Documento", null, null);
                            return false;}
                        break;
                    case 16:
                        var boleanoNumerico = false;
                        var boleanoRomano = false;
                        var numerico = codigo.substr(0,13);
                        var Romano = codigo.substr(13,3);
                        boleanoNumerico = !isNaN(parseFloat(numerico)) && isFinite(numerico);
                        if(Romano!= "III")
                        {
                        boleanoRomano =false
                        }
                        else
                        {
                        boleanoRomano=true;
                        }
                        if(boleanoNumerico==true && boleanoRomano==true)
                        {return true}
                        else 
                        {
                            comun.mensajeDeAlerta("Error el Código del Documento", null, null);
                            return false;}
                        break;
                    default:
                        comun.mensajeDeAlerta("verificar longitud del código del documento", null, null);
                        return false;
                        break;
                }
            }
            else
            {
                comun.mensajeDeAlerta("El Código no corresponde a documento de " + this.AreaQueConsulta.Area.Nombre, null, null);
            }
        },
        VerificaEnListado(){
            var codigo = this.CodigoBarras;
            if(this.ListaArchivo.length>0)
            {
                var check = this.ListaArchivo.filter(e=>e.CodigoBarras == codigo).length;
                if(check>0){
                    return true;
                }
            }
            return false;
        },
        DesglosaContenido: function (datos){
            let Contenido ="";

            if(datos.Volumenes!=null && datos.Volumenes.length>1)
            {
                Contenido = Contenido + '<b>TOMOS : </b>' + datos.Volumenes.length + '<br/>';
            }
            if(datos.Incidentes!=null && datos.Incidentes.length>0)
            {
                Contenido = Contenido + '<b>INCIDENTES : </b>' + datos.Incidentes.length + '<br/>';
            }
            if(datos.Tercerias!=null && datos.Tercerias.length>0)
            {
                Contenido = Contenido + '<b>TERCERIAS : </b>' + datos.Tercerias.length + '<br/>';
            }
            return Contenido;
        },
        DetectarEnter: function(e){
            
            if (e.keyCode==13)
            {
            this.CargaDocumento();
            }
        },
        DesglosaTipoJuicio: function(datos){
            var Juicio = "";
            if(datos.Materia.MateriaId!=9)
            {
                if(datos.Juicio!=null && datos.Juicio.Juicio!=null)
                {
                    Juicio = datos.Juicio.Juicio + "</br>" + "TIPO: " + datos.Juicio.Tramite;
                }
            }
            return Juicio;
        },
        DesglosaPartes: function(datos) {
            var Partes ="";
            if(datos!=null && datos.length>0)
            {
                $.each(datos, function(index, parte)
                {
                    Partes = Partes + parte.Tipo_Parte + " : " + parte.Nombre + " " + 
                    (parte.ApellidoPaterno!=null?parte.ApellidoPaterno : "") + " " + (parte.ApellidoMaterno!=null ? parte.ApellidoMaterno : "" ) + "</br>"
                })
                
            }
            return Partes;
        },
        EliminarDocumento(datos){
            var Index = this.ListaArchivo.indexOf(datos);
            var cargado = this.ListaCargada.find(a=>a.InventarioDocumentoId == datos.InventarioDocumentoId);

            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Desea Eliminar el Documento de la Lista para Envio al Archivo?",
                buttons: {
                  cancel: {
                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                  },
                  confirm: {
                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                  }
                },
                callback: (respuestaSalir) => {
                  if (respuestaSalir) {
                    $('#navListaArchivo_table').remove();
                    this.ListaArchivo.splice(Index,1);
                    if (cargado!=null || cargado!=undefined)
                    {
                        this.ListaEliminados.push(cargado);
                    };
                    if(this.ListaArchivo.length>15)
                    {
                        this.$nextTick(()=> { PaginarTabla('ListaArchivo_table', 15)});
                    };
                  }
               
                }
              });
        },
        Imprimir: async function(datos){
            console.log(this.AreaQueConsulta.Area.Nombre);
            //await this.GuardarLista(false);
            let nombreArea = this.AreaQueConsulta.Area.Nombre
            let Sede1 = datos.filter(e=>e.SedeArchivo.SedeArchivoId==1);
            let Sede2 = datos.filter(e=>e.SedeArchivo.SedeArchivoId==2);
            let Sede3 = datos.filter(e=>e.SedeArchivo.SedeArchivoId==3);
            let NombreFirma = this.SecretariosAcuerdos;
            let PuestoFirma = this.PuestoFirma;
            let _this = this;
            var printWin = window.open('', '_blank', 'width=1270,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('</head><body>');
            if(Sede1.length>0)
            {
                let expedientes = Sede1.filter(e=>e.TipoDocumento.TipoDocumentoId==1);
                let amparos = Sede1.filter(e=>e.TipoDocumento.TipoDocumentoId==4);
                let exhortos =Sede1.filter(e=>e.TipoDocumento.TipoDocumentoId==5);
                let tocas = Sede1.filter(e=>e.TipoDocumento.TipoDocumentoId==16);
                let CD = Sede1.filter(e=>e.TipoDocumento.TipoDocumentoId==23);
                let CA = Sede1.filter(e=>e.TipoDocumento.TipoDocumentoId==24);
                let CE = Sede1.filter(e=>e.TipoDocumento.TipoDocumentoId==26);
                let CJ = Sede1.filter(e=>e.TipoDocumento.TipoDocumentoId==27);
                let TOral = Sede1.filter(e=>e.TipoDocumento.TipoDocumentoId==29);
                let TOAdo = Sede1.filter(e=>e.TipoDocumento.TipoDocumentoId==30);
                let TEje = Sede1.filter(e=>e.TipoDocumento.TipoDocumentoId==31);


                if(expedientes.length>0)
                {
                    let srt= _this.createSheet(expedientes, (expedientes[0].Materia.MateriaId==6 ? "EXPEDIENTES PENALES" : "EXPEDIENTES PRINCIPALES"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(amparos.length>0)
                {
                    let srt= _this.createSheet(amparos, ((amparos[0].Materia.MateriaId==6 || amparos[0].Materia.MateriaId==9)? "AMPAROS PENALES" : "CUADERNOS DE AMPAROS"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(exhortos.length>0)
                {
                    let srt= _this.createSheet(exhortos, ((exhortos[0].Materia.MateriaId==6 || exhortos[0].Materia.MateriaId==9)? "EXHORTOS PENALES" : "EXHORTOS"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if (tocas.length>0)
                {
                    let srt= _this.createSheet(tocas, ((tocas[0].Materia.MateriaId==6 )? "TOCAS PENALES" : "TOCAS CIVILES"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CD.length>0)
                {
                    let srt= _this.createSheet(CD, "CARPETAS DIGITALES", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CA.length>0)
                {
                    let srt= _this.createSheet(CA, "CARPETAS ADMINISTRATIVAS", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CE.length>0)
                {
                    let srt= _this.createSheet(CE, "CARPETAS DE EJECUCIÓN", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CJ.length>0)
                {
                    let srt= _this.createSheet(CJ, "CARPETAS DE JUICIO", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(TOral.length>0)
                {
                    let srt= _this.createSheet(TOral, "TOCAS ORALES", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(TOAdo.length>0)
                {
                    let srt= _this.createSheet(TOAdo, "TOCAS ORALES ADOLESCENTES", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(TEje.length>0)
                {
                    let srt= _this.createSheet(TEje, "TOCAS ORALES EJECUCIÓN", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
            }
            if(Sede2.length>0)
            {
                let expedientes = Sede2.filter(e=>e.TipoDocumento.TipoDocumentoId==1);
                let amparos = Sede2.filter(e=>e.TipoDocumento.TipoDocumentoId==4);
                let exhortos =Sede2.filter(e=>e.TipoDocumento.TipoDocumentoId==5);
                let tocas = Sede2.filter(e=>e.TipoDocumento.TipoDocumentoId==16);
                let CD = Sede2.filter(e=>e.TipoDocumento.TipoDocumentoId==23);
                let CA = Sede2.filter(e=>e.TipoDocumento.TipoDocumentoId==24);
                let CE = Sede2.filter(e=>e.TipoDocumento.TipoDocumentoId==26);
                let CJ = Sede2.filter(e=>e.TipoDocumento.TipoDocumentoId==27);
                let TOral = Sede2.filter(e=>e.TipoDocumento.TipoDocumentoId==29);
                let TOAdo = Sede2.filter(e=>e.TipoDocumento.TipoDocumentoId==30);
                let TEje = Sede2.filter(e=>e.TipoDocumento.TipoDocumentoId==31);


                if(expedientes.length>0)
                {
                    let srt= _this.createSheet(expedientes, (expedientes[0].Materia.MateriaId==6 ? "EXPEDIENTES PENALES" : "EXPEDIENTES PRINCIPALES"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(amparos.length>0)
                {
                    let srt= _this.createSheet(amparos, ((amparos[0].Materia.MateriaId==6 || amparos[0].Materia.MateriaId==9)? "AMPAROS PENALES" : "CUADERNOS DE AMPAROS"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(exhortos.length>0)
                {
                    let srt= _this.createSheet(exhortos, ((exhortos[0].Materia.MateriaId==6 || exhortos[0].Materia.MateriaId==9)? "EXHORTOS PENALES" : "EXHORTOS"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if (tocas.length>0)
                {
                    let srt= _this.createSheet(tocas, ((tocas[0].Materia.MateriaId==6 )? "TOCAS PENALES" : "TOCAS CIVILES"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CD.length>0)
                {
                    let srt= _this.createSheet(CD, "CARPETAS DIGITALES", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CA.length>0)
                {
                    let srt= _this.createSheet(CA, "CARPETAS ADMINISTRATIVAS", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CE.length>0)
                {
                    let srt= _this.createSheet(CE, "CARPETAS DE EJECUCIÓN", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CJ.length>0)
                {
                    let srt= _this.createSheet(CJ, "CARPETAS DE JUICIO", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(TOral.length>0)
                {
                    let srt= _this.createSheet(TOral, "TOCAS ORALES", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(TOAdo.length>0)
                {
                    let srt= _this.createSheet(TOAdo, "TOCAS ORALES ADOLESCENTES", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(TEje.length>0)
                {
                    let srt= _this.createSheet(TEje, "TOCAS ORALES EJECUCIÓN", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
            }
            if(Sede3.length>0)
            {
                let expedientes = Sede3.filter(e=>e.TipoDocumento.TipoDocumentoId==1);
                let amparos = Sede3.filter(e=>e.TipoDocumento.TipoDocumentoId==4);
                let exhortos =Sede3.filter(e=>e.TipoDocumento.TipoDocumentoId==5);
                let tocas = Sede3.filter(e=>e.TipoDocumento.TipoDocumentoId==16);
                let CD = Sede3.filter(e=>e.TipoDocumento.TipoDocumentoId==23);
                let CA = Sede3.filter(e=>e.TipoDocumento.TipoDocumentoId==24);
                let CE = Sede3.filter(e=>e.TipoDocumento.TipoDocumentoId==26);
                let CJ = Sede3.filter(e=>e.TipoDocumento.TipoDocumentoId==27);
                let TOral = Sede3.filter(e=>e.TipoDocumento.TipoDocumentoId==29);
                let TOAdo = Sede3.filter(e=>e.TipoDocumento.TipoDocumentoId==30);
                let TEje = Sede3.filter(e=>e.TipoDocumento.TipoDocumentoId==31);


                if(expedientes.length>0)
                {
                    let srt= _this.createSheet(expedientes, (expedientes[0].Materia.MateriaId==6 ? "EXPEDIENTES PENALES" : "EXPEDIENTES PRINCIPALES"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(amparos.length>0)
                {
                    let srt= _this.createSheet(amparos, ((amparos[0].Materia.MateriaId==6 || amparos[0].Materia.MateriaId==9)? "AMPAROS PENALES" : "CUADERNOS DE AMPAROS"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(exhortos.length>0)
                {
                    let srt= _this.createSheet(exhortos, ((exhortos[0].Materia.MateriaId==6 || exhortos[0].Materia.MateriaId==9)? "EXHORTOS PENALES" : "EXHORTOS"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if (tocas.length>0)
                {
                    let srt= _this.createSheet(tocas, ((tocas[0].Materia.MateriaId==6 )? "TOCAS PENALES" : "TOCAS CIVILES"), nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CD.length>0)
                {
                    let srt= _this.createSheet(CD, "CARPETAS DIGITALES", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CA.length>0)
                {
                    let srt= _this.createSheet(CA, "CARPETAS ADMINISTRATIVAS", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CE.length>0)
                {
                    let srt= _this.createSheet(CE, "CARPETAS DE EJECUCIÓN", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(CJ.length>0)
                {
                    let srt= _this.createSheet(CJ, "CARPETAS DE JUICIO", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(TOral.length>0)
                {
                    let srt= _this.createSheet(TOral, "TOCAS ORALES", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(TOAdo.length>0)
                {
                    let srt= _this.createSheet(TOAdo, "TOCAS ORALES ADOLESCENTES", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                if(TEje.length>0)
                {
                    let srt= _this.createSheet(TEje, "TOCAS ORALES EJECUCIÓN", nombreArea, NombreFirma, PuestoFirma);
                    printWin.document.write(srt);
                }
                // printWin.document.write('<div class="col-md-12" style="page-break-before: always">');
                // printWin.document.write('   <div class="area">');
                // printWin.document.write('       <div class="row">');
                // printWin.document.write('           <div class="col-3 align-self-center">');
                // printWin.document.write('               <img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
                // printWin.document.write('           <div class="col-6 text-center align-self-center">');
                // printWin.document.write('               <h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
                // printWin.document.write('           <div class="col-3"></div>');
                // printWin.document.write('       </div>');
                // printWin.document.write('       <div class="row">');
                // printWin.document.write('           <div class="col-12 align-self-center" >');
                // printWin.document.write('               <div class="text-center">');
                // printWin.document.write('                   <h5 class="text-center">LISTADO DE DOCUMENTOS PARA REINGRESO</h5>');
                // printWin.document.write('               </div>');
                // printWin.document.write('           </div>');
                // printWin.document.write('       </div>');
                // printWin.document.write('       <div class="row">');
                // printWin.document.write('           <div class="col-12 align-self-center" >');
                // printWin.document.write('               <div class="text-center">');
                // printWin.document.write('                   <h6 class="text-center">RECEPCIÓN SEDE '+ Sede3[0].SedeArchivo.Nombre+ '</h6>');
                // printWin.document.write('               </div>');
                // printWin.document.write('           </div>');
                // printWin.document.write('       </div>');
                // printWin.document.write('       <div class="row">');
                // printWin.document.write('           <div class="col-12 text-right">');
                // printWin.document.write('               <label>Aguascalientes, Ags., a  '+ moment(_this.FechaEnvio).format('DD/MM/YYYY') + '</label>');
                // printWin.document.write('           </div>');
                // printWin.document.write('       </div>');
                // printWin.document.write('       <div class="row">');
                // printWin.document.write('           <div>');
                // printWin.document.write('               <label>Area: '+ nombreArea +'</label>');
                // printWin.document.write('           </div>');
                // printWin.document.write('       </div>');
                // // Inicio Datos del Listado

                // printWin.document.write('   <div class="row">');
                // printWin.document.write('           <div>');
                // printWin.document.write('               <label>Total de Documentos : '+ Sede3.length +'</label>');
                // printWin.document.write('           </div>');
                // printWin.document.write('   </div>');
                // printWin.document.write('   <div class="row">');              
                // printWin.document.write('           <div class="table-responsive">');
                // printWin.document.write('               <table class="table table-striped table-light table-sm table-bordered" style="page-break-before: auto;">');
                // printWin.document.write('                   <thead class="thead-dark" style="display:table-header-group"><tr><th></th><th>Expediente</th><th>Juicio</th><th>Partes</th><th>Anexos</th>');
                // printWin.document.write('                       </tr></thead><tbody class="text-dark">');
                // var contador = 0;
                // $.each(Sede3, function(index, Lista)
                // {
                //     console.log(Lista)
                //     contador +=1;
                //     var CadenaTexto = _this.DesglosaContenido(Lista);
                //     var JuicioTexto = _this.DesglosaTipoJuicio(Lista);
                //     var PartesTexto = _this.DesglosaPartes(Lista.Partes);
                //     printWin.document.write('<tr style="page-break-inside:avoid; page-break-after:auto">');
                //     printWin.document.write('<td width ="30">'+ contador +'</td>');
                //     if(_this.AreaQueConsulta.Area.AreaId!=48 && _this.AreaQueConsulta.Area.AreaId!=51 && _this.AreaQueConsulta.Area.AreaId!=52 && _this.AreaQueConsulta.Area.AreaId!=53 && _this.AreaQueConsulta.Area.AreaId!=54 && _this.AreaQueConsulta.Area.AreaId!=56 )
                //     {
                //         printWin.document.write('<td width ="50">'+ Lista.Consecutivo +'/'+Lista.Anio +'</td>');
                //     }
                //     else
                //     {
                //         printWin.document.write('<td width ="50">'+ Lista.Consecutivo +'/'+Lista.Anio +'<br>'+(Lista.TipoDocumento.TipoDocumentoId==23?'CARPETA DIGITAL' : (Lista.TipoDocumento.TipoDocumentoId==24?'CARPETA ADMINISTRATIVA' : (Lista.TipoDocumento.TipoDocumentoId==26?'CARPETA DE EJECUCION': 'CARPETA DE JUICIO'))) +'</td>');
                //     }
                    
                //     if(Lista.TipoDocumento.TipoDocumentoId==5)
                //     {
                //         printWin.document.write('<td width ="250">EXHORTO</td>');
                //     }
                //     else
                //     {
                //         printWin.document.write('<td width ="250">'+ JuicioTexto +'</td>');
                //     }
                //     printWin.document.write('<td width ="350">'+ PartesTexto +'</td>');
                //     printWin.document.write('<td width ="350">'+ (Lista.Anexos!=null?Lista.Anexos: '') +'</td>');
                //     printWin.document.write('</tr>');
                // });
                // printWin.document.write('               </tbody></table>');
                // printWin.document.write('           </div>');
                // printWin.document.write('    </div>');
                // // Fin Datos del Listado
                // // Inicio Cuadro de Firmas
                // printWin.document.write('    <div class="row" style="page-break-inside:avoid; page-break-after:auto">');
                // printWin.document.write('           <div class="form-group col-5 align-self-center" style="border: 1px solid black";>');
                // printWin.document.write('               <br><br><br><br><br>');
                // printWin.document.write('               <div class="align-self-center text-center" style="border-top: 1px solid black;">');
                // printWin.document.write('                   <div class="align-self-center">');
                // printWin.document.write('                       <label><strong>NOMBRE COMPLETO</strong></label>');
                // printWin.document.write('                   </div>');
                // printWin.document.write('                   <div class="align-self-center text-center">');
                // printWin.document.write('                       <label><strong>ARCHIVO DE CONCENTRACIÓN</strong></label>');
                // printWin.document.write('                   </div>');
                // printWin.document.write('               </div>');
                // printWin.document.write('           </div>');
                // printWin.document.write('           <div class="form-group col-2"></div>');
                // if(this.AreaQueConsulta.Area.AreaId!=48 && this.AreaQueConsulta.Area.AreaId!=51 && this.AreaQueConsulta.Area.AreaId!=52 && this.AreaQueConsulta.Area.AreaId!=53 && this.AreaQueConsulta.Area.AreaId!=54 && this.AreaQueConsulta.Area.AreaId!=56 )
                // {
                //     if(this.AreaQueConsulta.Area.AreaId!=26 && this.AreaQueConsulta.Area.AreaId!=27 && this.AreaQueConsulta.Area.AreaId!=19 && this.AreaQueConsulta.Area.AreaId!=44 && this.AreaQueConsulta.Area.AreaId!=87)
                //     {
                //         printWin.document.write('           <div class="form-group col-5 align-self-center" style="border: 1px solid black";>');
                //         printWin.document.write('               <br><br><br><br><br>');
                //         printWin.document.write('               <div class="align-self-center text-center" style="border-top: 1px solid black; ">');
                //         printWin.document.write('                   <div class="align-self-center">');
                //         printWin.document.write('                       <label><strong>'+  (_this.SecretariosAcuerdos!=null ? _this.SecretariosAcuerdos : "") + '</strong></label>');
                //         printWin.document.write('                   </div>');
                //         printWin.document.write('                   <div class="align-self-center text-center">');
                //         printWin.document.write('                       <label><strong>PRIMER SECRETARIO DE ACUERDOS</strong></label>');
                //         printWin.document.write('                   </div>');
                //         if(_this.SecretariosAcuerdos!=null && _this.SecretariosAcuerdos.length<=40)
                //         {
                //             printWin.document.write('               <br>');
                //         }
                //         printWin.document.write('               </div>');
                //         printWin.document.write('          </div>');
                //         printWin.document.write('    </div>');
                //     }
                //     else
                //     {
                //         printWin.document.write('           <div class="form-group col-5 align-self-center" style="border: 1px solid black";>');
                //         printWin.document.write('               <br><br><br><br><br>');
                //         printWin.document.write('               <div class="align-self-center text-center" style="border-top: 1px solid black; ">');
                //         printWin.document.write('                   <div class="align-self-center">');
                //         printWin.document.write('                       <label><strong>' + (NombreFirma!=null ? NombreFirma :"") + '</strong></label>');
                //         printWin.document.write('                   </div>');
                //         printWin.document.write('                   <div class="align-self-center text-center">');
                //         printWin.document.write('                       <label><strong>'+ (PuestoFirma!=null ? PuestoFirma : "" ) +'</strong></label>');
                //         printWin.document.write('                   </div>');
                //         printWin.document.write('               </div>');
                //         printWin.document.write('          </div>');
                //         printWin.document.write('    </div>');
                //     }
                // }
                // else
                // {
                //     printWin.document.write('           <div class="form-group col-5 align-self-center" style="border: 1px solid black";>');
                //     printWin.document.write('               <br><br><br><br><br>');
                //     printWin.document.write('               <div class="align-self-center text-center" style="border-top: 1px solid black; ">');
                //     printWin.document.write('                   <div class="align-self-center">');
                //     printWin.document.write('                       <label><strong>' + (NombreFirma!=null ? NombreFirma :"") + '</strong></label>');
                //     printWin.document.write('                   </div>');
                //     printWin.document.write('                   <div class="align-self-center text-center">');
                //     printWin.document.write('                       <label><strong>'+ (PuestoFirma!=null ? PuestoFirma : "" ) +'</strong></label>');
                //     printWin.document.write('                   </div>');
                //     printWin.document.write('               </div>');
                //     printWin.document.write('          </div>');
                //     printWin.document.write('    </div>');
                // }
                // // Fin Cuadro de Firmas

                // printWin.document.write('</div>'); //fin de area
                // printWin.document.write('</div>'); //fin principal
            }
            printWin.document.write('</body></html>');
            //var css = '@page { size: Legal;  margin: 10mm 20mm 10mm 20mm; }',
            var css = '@page { size: 216mm 339mm;  margin: 15mm 15mm 20mm 15mm; }', //superior derecho abajo izquierdo
            head = printWin.document.head || document.getElementsByTagName('head')[0],
            style = printWin.document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet) {
            style.styleSheet.cssText = css;
            } else {
            style.appendChild(printWin.document.createTextNode(css));
            }
            head.appendChild(style);
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        agregarTomos: function (documento){
            this.Actuales= documento.Volumenes.length;
            this.InventarioId = documento
            this.agregaTomos = true;
        },
        EstatusModal(valor){
            this.agregaTomos = valor.Estatus;
            if(valor.Adicionales==true)
            {
                var filtrado = this.ListaArchivo.filter(e=>e.CodigoBarras == valor.Codigo);
                var indice = this.ListaArchivo.indexOf(filtrado[0]);
                this.ListaArchivo.splice(indice,1);
                this.CodigoBarras = valor.Codigo;
                this.CargaDocumento();
                comun.mensajeDeAlerta("Se agregaron los tomos al Documento correctamente", null, null)
            }
        },
        enabledButton(){
            this.onGuardar= true;
        },
        EditarAnexos(datos){
            this.DocumentoModalAnexo = datos;
            this.modalAnexos = true;
        },
        EstatusAnexos(valor){
            this.modalAnexos = valor.Estatus;
            if(valor.editado==true)
            {
                var filtro = this.ListaArchivo.filter(e=>e.InventarioDocumentoId == valor.id);
                var indice = this.ListaArchivo.indexOf(filtro[0]);
                this.ListaArchivo[indice].Anexos = valor.Anexos;
            }
        },
        sortAnioConsecutivo: function (a,b){
            if(a.TipoDocumento.TipoDocumentoId < b.TipoDocumento.TipoDocumentoId) return -1
            if(a.TipoDocumento.TipoDocumentoId > b.TipoDocumento.TipoDocumentoId) return 1
            if(a.Anio < b.Anio) return -1
            if(a.Anio > b.Anio) return 1
            if(a.Consecutivo < b.Consecutivo) return -1
            if(a.Consecutivo > b.Consecutivo) return 1
            return 0
        },
        TipoDocumentoHTML(tipo) {
            let TipoDocumento = ''
            switch(tipo.TipoDocumento.TipoDocumentoId)
            {
                case 1: 
                if(tipo.Materia.MateriaId==6)
                {
                    TipoDocumento = "EXPEDIENTE PENAL";
                }
                else
                {
                    TipoDocumento = "EXPEDIENTE PRINCIPAL";
                }
                break;
                case 2: 
                TipoDocumento = "TERCERÍA";
                break;
                case 4:
                    if(tipo.Materia.MateriaId==6 || tipo.Materia.MateriaId==9)
                    {
                        TipoDocumento = "AMPARO PENAL";
                    }
                    else
                    {
                        TipoDocumento = "CUADERNO DE AMPARO";
                    }
                    break;
                case 5:
                    if(tipo.Materia.MateriaId==6 || tipo.Materia.MateriaId==9)
                    {
                        TipoDocumento = "EXHORTO PENAL";
                    }
                    else
                    {
                        TipoDocumento = "EXHORTO";
                    } 
                    break;
                case 6: 
                    TipoDocumento = "REQUISITORIA";
                    break;
                case 10: 
                    TipoDocumento = "INCIDENTE";
                    break;
                case 11: 
                    TipoDocumento = "ROGATORIA";
                    break;
                case 12: 
                    TipoDocumento = "DESPACHO";
                    break;
                case 16:
                    if(tipo.Materia.MateriaId==6)
                    {
                        TipoDocumento = "TOCA PENAL";
                    }
                    else
                    {
                        TipoDocumento = "TOCA CIVIL";
                    }
                    break;
                case 23:
                    TipoDocumento="CARPETA DIGITAL";
                    break;
                case 24:
                    TipoDocumento="CARPETA ADMINISTRATIVA";
                    break;
                case 26:
                    TipoDocumento="CARPETA DE EJECUCIÓM";
                    break;
                case 27:
                    TipoDocumento="CARPETA DE JUICIO";
                    break;
                case 29:
                    TipoDocumento="TOCA ORAL"
                    break;
                case 30:
                    TipoDocumento="TOCA ORAL ADOLESCENTES"
                    break;
                case 31:
                    TipoDocumento="TOCA ORAL EJECUCIÓN"
                    break;
            };
            return TipoDocumento;
        },
        AccionImprimirEnviar(){
            var EnviarListado = this.MostrarEnviar
            if(EnviarListado==true)
            {
                bootbox.confirm({
                    title: "Mensaje del sistema",
                    message: "El envío del listado de re ingresos se generara con la impresión, desea continuar?",
                    buttons: {
                        cancel: {
                            label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                        },
                        confirm: {
                            label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir y Enviar'
                        }
                        },
                    callback: (respuestaSalir) => {
                        if (respuestaSalir) {
                            this.EnviarArchivo(true);
                            this.Imprimir(this.ListaArchivo);
                        };
                    }
                });
            }
            else
            {
                this.Imprimir(this.ListaArchivo);
            }
        },
        createSheet: function (Array, tDocumento, nArea, nFirma, pFirma )
        {   
             let _this = this;
                let textToWrite ='';
                textToWrite = textToWrite +'<div class="col-md-12" style="page-break-before: always">';
                textToWrite = textToWrite +'   <div class="area">';
                textToWrite = textToWrite +'       <div class="row">';
                textToWrite = textToWrite +'           <div class="col-3 align-self-center">';
                textToWrite = textToWrite +'               <img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>';
                textToWrite = textToWrite +'           <div class="col-6 text-center align-self-center">';
                textToWrite = textToWrite +'               <h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>';
                textToWrite = textToWrite +'           <div class="col-3"></div>';
                textToWrite = textToWrite +'       </div>';
                textToWrite = textToWrite +'       <div class="row">';
                textToWrite = textToWrite +'           <div class="col-12 align-self-center" >';
                textToWrite = textToWrite +'               <div class="text-center">';
                textToWrite = textToWrite +'                   <h5 class="text-center">LISTADO DE ' + tDocumento + ' PARA REINGRESO</h5>';
                textToWrite = textToWrite +'               </div>';
                textToWrite = textToWrite +'           </div>';
                textToWrite = textToWrite +'       </div>';
                textToWrite = textToWrite +'       <div class="row">';
                textToWrite = textToWrite +'           <div class="col-12 align-self-center" >';
                textToWrite = textToWrite +'               <div class="text-center">';
                textToWrite = textToWrite +'                   <h6 class="text-center">RECEPCIÓN SEDE '+ Array[0].SedeArchivo.Nombre+ '</h6>';
                textToWrite = textToWrite +'               </div>';
                textToWrite = textToWrite +'           </div>';
                textToWrite = textToWrite +'       </div>';
                textToWrite = textToWrite +'       <div class="row">';
                textToWrite = textToWrite +'           <div class="col-12 text-right">';
                textToWrite = textToWrite +'               <label>Aguascalientes, Ags., a  '+ moment(_this.FechaEnvio).format('DD/MM/YYYY') + '</label>';
                textToWrite = textToWrite +'           </div>';
                textToWrite = textToWrite +'       </div>';
                textToWrite = textToWrite +'       <div class="row">';
                textToWrite = textToWrite +'           <div >';
                textToWrite = textToWrite +'               <label>Area: '+ nArea +'</label>';
                textToWrite = textToWrite +'           </div>';
                textToWrite = textToWrite +'       </div>';
                // Inicio Datos del Listado

                textToWrite = textToWrite +'   <div class="row">';
                textToWrite = textToWrite +'           <div>';
                textToWrite = textToWrite +'               <label>Total de Documentos : '+ Array.length +'</label>';
                textToWrite = textToWrite +'           </div>';
                textToWrite = textToWrite +'   </div>';
                textToWrite = textToWrite +'   <div class="row">';              
                textToWrite = textToWrite +'           <div class="table-responsive">';
                textToWrite = textToWrite +'               <table class="table table-striped table-light table-sm table-bordered" style="page-break-before: auto;">';
                textToWrite = textToWrite +'                   <thead class="thead-dark" style="display:table-header-group"><tr><th></th><th>Expediente</th><th>Juicio</th><th>Partes</th><th>Anexos</th>';
                textToWrite = textToWrite +'                       </tr></thead><tbody class="text-dark">';
                var contador = 0;
                $.each(Array, function(index, Lista)
                {
                    contador +=1;
                    var CadenaTexto = _this.DesglosaContenido(Lista);
                    var JuicioTexto = _this.DesglosaTipoJuicio(Lista);
                    var PartesTexto = _this.DesglosaPartes(Lista.Partes);
                    textToWrite = textToWrite +'<tr style="page-break-inside:avoid; page-break-after:auto">';
                    textToWrite = textToWrite +'<td width ="30">'+ contador +'</td>';
                    textToWrite = textToWrite +'<td width ="50">'+ Lista.Consecutivo +'/'+Lista.Anio +'</td>';
                    if(Lista.TipoDocumento.TipoDocumentoId==5)
                    {
                        textToWrite = textToWrite +'<td width ="250">EXHORTO</td>';
                    }
                    else
                    {
                        textToWrite = textToWrite +'<td width ="250">'+ JuicioTexto +'</td>';
                    }
                    textToWrite = textToWrite +'<td width ="350">'+ PartesTexto +'</td>';
                    textToWrite = textToWrite +'<td width ="350">'+ (Lista.Anexos!=null?Lista.Anexos: '') +'</td>';
                    textToWrite = textToWrite +'</tr>';
                });
                textToWrite = textToWrite +'               </tbody></table>';
                textToWrite = textToWrite +'           </div>';
                textToWrite = textToWrite +'    </div>';
                // Fin Datos del Listado
                // Inicio Cuadro de Firmas
                textToWrite = textToWrite +'    <div class="row" style="page-break-inside:avoid; page-break-after:auto">';
                textToWrite = textToWrite +'           <div class="form-group col-5 align-self-center" style="border: 1px solid black;">';
                textToWrite = textToWrite +'               <br><br><br><br><br>';
                textToWrite = textToWrite +'               <div class="align-self-center text-center" style="border-top: 1px solid black;">';
                textToWrite = textToWrite +'                   <div class="align-self-center">';
                textToWrite = textToWrite +'                       <label><strong>NOMBRE COMPLETO</strong></label>';
                textToWrite = textToWrite +'                   </div>';
                textToWrite = textToWrite +'                   <div class="align-self-center text-center">';
                textToWrite = textToWrite +'                       <label><strong>ARCHIVO DE CONCENTRACIÓN</strong></label>';
                textToWrite = textToWrite +'                   </div>';
                textToWrite = textToWrite +'               <br>';
                textToWrite = textToWrite +'               </div>';
                textToWrite = textToWrite +'           </div>';
                textToWrite = textToWrite +'           <div class="form-group col-2"></div>';
                if(this.AreaQueConsulta.Area.AreaId!=48 && this.AreaQueConsulta.Area.AreaId!=51 && this.AreaQueConsulta.Area.AreaId!=52 && this.AreaQueConsulta.Area.AreaId!=53 && this.AreaQueConsulta.Area.AreaId!=54 )
                {
                    if(this.AreaQueConsulta.Area.AreaId!=26 && this.AreaQueConsulta.Area.AreaId!=27 && this.AreaQueConsulta.Area.AreaId!=19 && this.AreaQueConsulta.Area.AreaId!=44 && this.AreaQueConsulta.Area.AreaId!=87)
                    {
                        textToWrite = textToWrite +'           <div class="form-group col-5 align-self-center" style="border: 1px solid black;">';
                        textToWrite = textToWrite +'               <br><br><br><br><br>';
                        textToWrite = textToWrite +'               <div class="align-self-center text-center" style="border-top: 1px solid black;">';
                        textToWrite = textToWrite +'                   <div class="align-self-center">';
                        textToWrite = textToWrite +'                       <label><strong>'+  (_this.SecretariosAcuerdos!=null ? _this.SecretariosAcuerdos : "") + '</strong></label>';
                        textToWrite = textToWrite +'                   </div>';
                        textToWrite = textToWrite +'                   <div class="align-self-center text-center">';
                        textToWrite = textToWrite +'                       <label><strong>PRIMER SECRETARIO DE ACUERDOS</strong></label>';
                        textToWrite = textToWrite +'                   </div>';
                        if(_this.SecretariosAcuerdos!=null && _this.SecretariosAcuerdos.length<=40)
                        {
                            textToWrite = textToWrite +'               <br>';
                        }
                        textToWrite = textToWrite +'               </div>';
                        textToWrite = textToWrite +'          </div>';
                        textToWrite = textToWrite +'    </div>';
                    }
                    else
                    {
                        textToWrite = textToWrite +'           <div class="form-group col-5 align-self-center" style="border: 1px solid black;">';
                        textToWrite = textToWrite +'               <br><br><br><br><br>';
                        textToWrite = textToWrite +'               <div class="align-self-center text-center" style="border-top: 1px solid black;">';
                        textToWrite = textToWrite +'                   <div class="align-self-center">';
                        textToWrite = textToWrite +'                       <label><strong>' + (nFirma!=null ? nFirma :"") + '</strong></label>';
                        textToWrite = textToWrite +'                   </div>';
                        textToWrite = textToWrite +'                   <div class="align-self-center text-center">';
                        textToWrite = textToWrite +'                       <label><strong>'+ (pFirma!=null ? pFirma : "" ) +'</strong></label>';
                        textToWrite = textToWrite +'                   </div>';
                        textToWrite = textToWrite +'               </div>';
                        textToWrite = textToWrite +'          </div>';
                        textToWrite = textToWrite +'    </div>';
                    }
                }
                else
                {
                    textToWrite = textToWrite +'           <div class="form-group col-5 align-self-center" style="border: 1px solid black;">';
                    textToWrite = textToWrite +'               <br><br><br><br><br>';
                    textToWrite = textToWrite +'               <div class="align-self-center text-center" style="border-top: 1px solid black;">';
                    textToWrite = textToWrite +'                   <div class="align-self-center">';
                    textToWrite = textToWrite +'                       <label><strong>' + (nFirma!=null ? nFirma :"") + '</strong></label>';
                    textToWrite = textToWrite +'                   </div>';
                    textToWrite = textToWrite +'                   <div class="align-self-center text-center">';
                    textToWrite = textToWrite +'                       <label><strong>'+ (pFirma!=null ? pFirma : "" ) +'</strong></label>';
                    textToWrite = textToWrite +'                   </div>';
                    textToWrite = textToWrite +'               </div>';
                    textToWrite = textToWrite +'          </div>';
                    textToWrite = textToWrite +'    </div>';
                }
                // Fin Cuadro de Firmas

                textToWrite = textToWrite +'</div>'; //fin de area
                textToWrite = textToWrite +'</div>'; //fin principal

                return textToWrite;
        }
    },
    mounted(){
        setTimeout(()=>{
            this.AreaQueConsulta.Area.AreaId=0
            this.AreaQueConsulta = this.$store.state.Login_Usuario;
            if(this.AreaQueConsulta.Area.AreaId==21)
            {
                this.ObtenSolicitudes();
            }
        }, 500 );
        
        
    },
    beforeRouteLeave (to, from, next) {
        if(this.ListaArchivo.length!=this.ConteoInicial || this.onGuardar== true)
        {
            bootbox.confirm({
                    title: "Mensaje del sistema",
                    message: "Existen Cambios en la Lista para Envío al Archivo, perderá los cambios si no se guarda lista.<br />¿Desea continuar?",
                    buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y salir'
                    }
            },
            callback: (respuestaSalir) => {
                  if (respuestaSalir) {
                    next();
                  }
                  else{
                      next(false);
                  }
                }
            });
        }
        else
        {
            next()
        }
    }
}
</script>
<style scoped>
    .thead-custom {
        background-color: #004746;
        color: white;
    }
    .animado {
        color: hsl(0, 95%, 49%);
        font-size: 23px;
        font-weight: bold;
        font-family: "Myriad";
        
        cursor: pointer;
        text-transform: uppercase;
        }

    .animado {
            background: linear-gradient(to right, hsl(152, 93%, 21%) 0, hsl(152, 93%, 21%) 30%, hsl(0, 100%, 1%) 20%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            animation: shine 7s infinite linear;
        }

    @keyframes shine {
            0% {
                background-position: 0;
            }
            60% {
                background-position: 600px;
            }
            100% {
                background-position: 600px;
            }
        }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Solicitudes/SolicitudesActivas.vue